/**
 * کش blob پخش ضبط‌های ماک در صفحهٔ نتیجه:
 * - هر audio_id فقط یک‌بار از سرور گرفته می‌شود (باز/بسته کردن آکاردئون دوباره درخواست نمی‌زند).
 * - صف دریافت: حداکثر یک fetch هم‌زمان به stream تا فشار روی سرور کم بماند.
 * - با revokeAll هنگام ترک صفحه، blob URLها آزاد می‌شوند.
 */
export function createMockResultBlobCache(fetchBlob: (audioId: number) => Promise<string>) {
  const map = new Map<number, string>();
  let queue: Promise<unknown> = Promise.resolve();

  const enqueue = <T,>(fn: () => Promise<T>): Promise<T> => {
    const p = queue.then(() => fn());
    queue = p.catch(() => {});
    return p;
  };

  const getOrFetch = (audioId: number): Promise<string> => {
    const hit = map.get(audioId);
    if (hit) return Promise.resolve(hit);
    return enqueue(async () => {
      if (map.has(audioId)) return map.get(audioId)!;
      const url = await fetchBlob(audioId);
      map.set(audioId, url);
      return url;
    });
  };

  const revokeAll = () => {
    Array.from(map.values()).forEach((u) => {
      try {
        URL.revokeObjectURL(u);
      } catch {
        /* ignore */
      }
    });
    map.clear();
    queue = Promise.resolve();
  };

  return { getOrFetch, revokeAll };
}
